// @flow

import React, { type Node } from 'react';
import { getGatewayVoucherUrl, usePendingIncomingPayment, redirectIfCheckForConfirmationIsEnabled } from '@tectonics/prs/incoming-payment';
import { LinkButton } from '../commons/render-helpers';

export function PrintVoucherButton(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const buttonMessage = 'Imprimir Recibo Efecty';
  const voucherUrl = getGatewayVoucherUrl(incomingPayment);
  return (
    <LinkButton inverseStyle={false} aria-label={buttonMessage} type="primary" flat as="a" target="blank" href={voucherUrl} contentDesktop={buttonMessage} data-test-id="efecty-print-button" onClick = { () => redirectIfCheckForConfirmationIsEnabled(incomingPayment) } />
  );
}
